const getUserLocationPromise = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation?.getCurrentPosition)
      reject(new Error(getUserLocationPromise.NOT_SUPPORTED));

    navigator.geolocation.getCurrentPosition(
      (r) => resolve({ lat: r.coords.latitude, lng: r.coords.longitude }),
      (e) => reject(e)
    );
  });

getUserLocationPromise.NOT_SUPPORTED = 'NOT_SUPPORTED';

export default getUserLocationPromise;
